/*doc
---
title: shown()
name: shown
category: Javascript - General
---

This is a custom version of [jQuery's `show()`](http://api.jquery.com/show/) and
only works when used with `hidden()`. **Use this instead of `show()`**

This version removes the Bootstrap `hidden` class from the element, and it
also will set the `aria-hidden` attribute to `false`.

```html_example
<button type="button" class="shown-example-btn btn btn-lg btn-primary">Show</button>

<h1 class="shown-example">This will is now be shown</h1>
```

```js_example
$(document).on('turbolinks:load', function() {
  // Element hidden with `hidden()`
  $('.shown-example').hidden()

  $('.shown-example-btn').click(function() {
    $('.shown-example').shown()
  })
})
```
*/
(function ($) {
  'use strict'

  $.fn.shown = shown

  function shown() {
    return this.each(function() {
      $(this)
        .removeClass('hidden')
        .attr('aria-hidden', false)
    })
  }

}(jQuery))
